import { render } from "./stub_page.vue?vue&type=template&id=5a24bc34"
import script from "./stub_page.vue?vue&type=script&lang=js"
export * from "./stub_page.vue?vue&type=script&lang=js"

import "./stub_page.vue?vue&type=style&index=0&id=5a24bc34&lang=stylus"

import exportComponent from "/Volumes/KINDSTON/Lokal Google Drive/PROJECT/TECHSS/techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__